<template>
  <div class="header-wrapper">
    <header class="header">
      <svgicon class="icon" name="logo" width="165px" height="16px" :original="true"></svgicon>
      <h2 class="header-title">Сryptocurrency Checkout Demo</h2>
    </header>
  </div>
</template>

<script>
import '../assets/compiled-icons';
  export default {
    name: 'Header'
  };
</script>

<style scoped>
@import "../styles/colors.css";
@import "../styles/consts.css";

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  height: 146px;
  width: 100%;
  max-width: 1320px;
  position: relative;

  &-wrapper {
    display: flex;
    justify-content: center;
  }

  &-title {
    font-size: 20px;
    color: $gray;
  }
}

.icon {
  position: absolute;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue